import { render, staticRenderFns } from "./loadedDevicePropertyCard.vue?vue&type=template&id=504f5ae0&scoped=true"
import script from "./loadedDevicePropertyCard.vue?vue&type=script&lang=js"
export * from "./loadedDevicePropertyCard.vue?vue&type=script&lang=js"
import style0 from "./loadedDevicePropertyCard.vue?vue&type=style&index=0&id=504f5ae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f5ae0",
  null
  
)

export default component.exports